import { EmailTemplate } from "../../types/EmailTemplate";

export const TemplateDefault: EmailTemplate = {
  id: "default",
  name: "Template standard",
  description: "Structure avec bannière, titre, message et double appel à l'action",
  templateFile: "default",
  previewImage: "/templates/previews/default-preview.png", // Image statique optionnelle
  previewData: {
    heroImage: "https://via.placeholder.com/600x200/ff8c00/ffffff?text=BANNIERE+EXEMPLE",
    title: "🎉 Offre exceptionnelle",
    subtitle: "Profitez de -50% sur tous nos services",
    cta1Text: "Je profite de l'offre",
    cta1Url: "https://izilifepay.com/offre",
    message:
      "Nous vous offrons une réduction exceptionnelle de 50% sur tous nos services. Valable jusqu'au 31 décembre 2026.<br><br>Ne manquez pas cette opportunité unique !",
    cta2Text: "En savoir plus",
    cta2Url: "https://izilifepay.com/conditions",
  },
  fields: [
    {
      name: "heroImage",
      label: "Bannière",
      type: "image",
      required: false,
    },
    {
      name: "title",
      label: "Titre principal",
      type: "text",
      required: true,
      placeholder: "Ex: Offre spéciale",
      defaultValue: "Offre spéciale",
    },
    {
      name: "subtitle",
      label: "Sous-titre",
      type: "text",
      required: false,
      placeholder: "Ex: Profitez de cette opportunité",
    },
    {
      name: "cta1Text",
      label: "Texte du bouton principal",
      type: "text",
      required: true,
      placeholder: "Ex: J'en profite",
      defaultValue: "J'en profite",
    },
    {
      name: "cta1Url",
      label: "Lien du bouton principal",
      type: "url",
      required: true,
      placeholder: "https://...",
      defaultValue: "https://izilifepay.com",
    },
    {
      name: "message",
      label: "Message",
      type: "textarea",
      required: true,
      placeholder: "Rédigez votre message ici...",
    },
    {
      name: "cta2Text",
      label: "Texte du second bouton",
      type: "text",
      required: false,
      placeholder: "Ex: En savoir plus",
    },
    {
      name: "cta2Url",
      label: "Lien du second bouton",
      type: "url",
      required: false,
      placeholder: "https://...",
    },
  ],
};
